"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricLegend = void 0;
var React = require("react");
var metrics_engine_1 = require("@tableau/metrics-engine");
var MetricLegend = /** @class */ (function (_super) {
    __extends(MetricLegend, _super);
    function MetricLegend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderLegend = function (color, dateRange, windowSwitcherDescribedById) {
            return (React.createElement("div", { style: container },
                React.createElement("div", { style: __assign(__assign({}, box), { backgroundColor: color }) }),
                React.createElement("div", { style: text, id: windowSwitcherDescribedById },
                    _this.props.dateFormatter.legend(dateRange),
                    ' ')));
        };
        _this.render = function () {
            var color = _this.props.metricColorIndicatorsEnabled ? metrics_engine_1.MetricsGrey : metrics_engine_1.MetricBlue;
            return (React.createElement("div", null,
                _this.renderLegend(color, _this.props.currentRange, 'current-legend'),
                _this.props.comparisonRange
                    ? _this.renderLegend(metrics_engine_1.MetricComparisonColor, _this.props.comparisonRange, 'comparison-legend')
                    : null));
        };
        return _this;
    }
    return MetricLegend;
}(React.Component));
exports.MetricLegend = MetricLegend;
var container = {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '5px',
    marginBottom: '5px',
    height: '20px',
};
var box = {
    height: '14px',
    width: '14px',
    borderRadius: '2px',
    marginRight: '2px',
};
var text = {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '5px',
};
//# sourceMappingURL=MetricLegend.js.map